import React from 'react'

// Original vector from Figma frame 220, Rectangle 2725: the patient view selector caret. The select
// passes its icon classes (position, open rotation) through className and centers a 24px icon box;
// the margins move the caret onto its Figma spot, 144px after the title start and 8px above its baseline.
const ViewSelectorCaretIcon = ({ className }) => (
  <span
    className={className}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 24,
      height: 24,
      marginTop: 1.44,
      marginRight: 0.7
    }}
  >
    <svg width={10} height={6} viewBox="684 197 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M685.367 198.64C684.824 197.989 685.287 197 686.135 197H691.865C692.713 197 693.176 197.989 692.633 198.64L689.768 202.078C689.368 202.558 688.632 202.558 688.232 202.078L685.367 198.64Z"
        fill="#001335"
      />
    </svg>
  </span>
)

export default ViewSelectorCaretIcon
